import React, { useState, useEffect, Suspense } from "react";

import styles from "./Field.module.scss";

import Label from "./Label";

const CreatableSelectLazy = React.lazy(() => import("react-select/creatable"));
const CreatableSelect = (props) => (
  <Suspense fallback={null}>
    <CreatableSelectLazy {...props} />
  </Suspense>
);

const CustomSelect = React.forwardRef(
  (
    { id, label, isRequired, description, placeholder, onChange = () => {}, errors, defaultValue },
    ref
  ) => {
    const [inputValue, setInputValue] = useState("");
    const createOption = (label) => ({
      label,
      value: label,
    });

    const [value, setValue] = useState((defaultValue || []).map(createOption));

    const isInvalid = errors[id] ? "is-invalid" : "";

    const customStyles = {
      control: (provided, state) => ({
        ...styles.field,
        ...styles.select,
      }),
    };

    const components = {
      DropdownIndicator: null,
      ClearIndicator: null,
    };

    const handleChange = (value) => {
      setValue(value);
    };

    const handleInputChange = (inputValue) => {
      setInputValue(inputValue);
    };

    const addItem = () => {
      if (!inputValue) return;
      setInputValue("");
      setValue([...value, createOption(inputValue)]);
    };

    const handleKeyDown = (event) => {
      switch (event.key) {
        case "Enter":
        case "Tab":
          addItem();
          event.preventDefault();
          break;
        default:
          break;
      }
    };

    const handleBlur = () => {
      addItem();
    };

    //this is passed to the controller
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => onChange(value.map(({ value }) => value)), [value]);

    return (
      <div className={styles.formGroup}>
        <Label id={id} label={label} isRequired={isRequired} />
        <span className={`d-block ${styles.description}`}>{description}</span>
        <div className="row no-gutters">
          <div className="col">
            <CreatableSelect
              styles={customStyles}
              className={`${styles.field} ${styles.select} form-control ${isInvalid} h-auto`}
              components={components}
              inputValue={inputValue}
              isMulti
              menuIsOpen={false}
              onChange={handleChange}
              onInputChange={handleInputChange}
              onKeyDown={handleKeyDown}
              onBlur={handleBlur}
              placeholder={placeholder}
              value={value}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default CustomSelect;
